export function calculateUnitPrice(
  lineItem: { total?: number; quantity?: number },
  moneyFormat?: { amount_multiplied_by?: number }
): number {
  const total = lineItem.total ?? 0
  const quantity = lineItem.quantity ?? 1
  const multiplier = moneyFormat?.amount_multiplied_by ?? 100

  return total / quantity / multiplier
}
